













































































































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IEmail } from "@/models/emails";
import { DataModules } from "@/store/modules/data";
import Context from "@/mixins/context";

@Component
export default class ClientEmailRow extends Mixins(Context) {
  // Props

  @Prop({ default: null })
  public readonly email!: IEmail | null;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public isLoading!: boolean;

  // Computed

  public get bouncedMsg() {
    if (!this.email?.bounced_at) return "";
    return this.$t("_sentence.email_bounced_msg", {
      datetime: this.$moment
        .utc(this.email.bounced_at)
        .format(this.$t("_datetime.datetime.long") as string)
    });
  }

  // Methods

  public copyToClipboard() {
    return this.$copyToClipboard(this.email?.email);
  }

  public editEmail() {
    if (!this.email) return;
    return this.$store.dispatch(
      `data/${DataModules.CLIENTS_EMAILS}/openEditModal`,
      this.email
    );
  }

  public async deleteEmail() {
    if (!this.email) return;
    this.$store.dispatch(`data/${DataModules.CLIENTS_EMAILS}/confirmDelete`, {
      email: this.email,
      onConfirm: () => this.$emit("refresh")
    });
  }

  public async markAsVerified() {
    if (!this.email) return;
    const onSuccess: boolean = await this.$store.dispatch(
      `data/${DataModules.CLIENTS_EMAILS}/markAsVerified`,
      { email: this.email }
    );
    if (onSuccess) return this.$emit("refresh");
  }

  public async resendVerificationEmail() {
    if (!this.email) return;
    return this.$store.dispatch(
      `data/${DataModules.CLIENTS_EMAILS}/resendVerificationEmail`,
      { email: this.email }
    );
  }

  public async setAsDefault() {
    if (!this.email) return;
    const onSuccess: boolean = await this.$store.dispatch(
      `data/${DataModules.CLIENTS_EMAILS}/makeDefault`,
      { email: this.email }
    );
    if (onSuccess) return this.$emit("refresh");
  }
}
